class DuskStoreLocator extends HTMLElement {
    constructor() {
        super();
        this.map,
        this.geocoder,
        this.infoWindow,
        this.storeMarkers = [],
        this.searchMarker,
        this.cityCircle,
        this.currentPos = null;
        this.showMap = JSON.parse(this.dataset.showMap)
        this.stores = []
        if(this.showMap) {
            this.mapOptions = JSON.parse(this.querySelector('[data-map-options]').textContent)
        }
        this.storeCards = this.querySelectorAll('.stores-list .card-store')
        this.cardList = this.querySelector('.cardList');

        this.findStoresButton = this.querySelector('.stores-list .button')
        this.findStoresInput = this.querySelector('.stores-list input')

        this.findStoresResetButton = this.querySelector('.button-icon-reset')
    }
    
    connectedCallback() {
        this.loadStores().then(() => {
            this.initMap()

            if(this.showMap) {
                this.storeCards?.forEach((title)=>{
                    title.addEventListener('click', this.showStoreOnMap.bind(this))
                })
            }
            this.findStoresButton?.addEventListener('click', this.searchPlaces.bind(this))
            this.findStoresInput?.addEventListener('keyup', this.searchPlaces.bind(this))

            this.findStoresResetButton?.addEventListener('click', () => {
                this.findStoresInput.value = '';
                this.querySelectorAll('.card-store').forEach(card => card.classList.remove('hidden'));
                this.resetMap();
            });
            this.findStoresInput?.focus()
           
            this.initBookingPopup()

        });
    }

    async loadStores() {
        try {
            // const res = await fetch('https://opensheet.elk.sh/1El6-mzIQ4QH_TQuyVIXJPLfubmjREzwzXW9fC-Wj3Xk/Data');
            const res = await fetch('https://opensheet.elk.sh/1gNj6WudWELAdXwrdJ1HPvCwj8miqvmC49AnUeBlSmHg/Data');
            this.stores = await res.json();

            const cardHTML = this.stores.map(store => {
                let Telehealth_App  = this.getTelehealthLabel(store);
                console.log(store)

                return `
                <div class="card-store"
                    data-id="${store.id}"
                    data-url="${store.website || '#'}"
                    data-postcode="${store.zip?.toLowerCase() || ''}"
                    data-state="${store.state?.toLowerCase() || ''}"
                    data-city="${store.city?.toLowerCase() || ''}"
                    data-latitude="${store.latitude}"
                    data-longitude="${store.longitude}"
                    data-type="${store.type || ''}"
                    data-telehealth="${store.telehealth_available || store.telehealth_only || ''}"
                >
                    <div class="title" style="${window.storeLocator?.settings.show_doctor_name_list ? '' : 'display: none;'}">
                        <span>${store.Title} ${store.FName} ${store.LName}</span> 
                    </div>
                    <div class="subtitle" style="${window.storeLocator?.settings.show_doctor_specialty_list ? '' : 'display: none;'}">
                        <span>${store.Specialty}</span>${store.Secondary_Specialty ? `<span>${store.Secondary_Specialty}</span>` : ''}
                    </div>
                    <address>
                        <div class="address3">
                            <span class="city">${store.city || ''}, </span>
                            <span class="state">${store.state || ''} </span>
                            <span class="zip">${store.zip || ''}</span>
                            <span class="country">${store.country || ''}</span>
                        </div>
                        <div class="phone" data-phone="${store.phone || ''}"></div>
                        <div class="telehealth">${Telehealth_App}</div>
                    </address>
                    <div class="distance"></div>
                    <div class="actions">
                        <a class="btn btn--store-locator js-book-an-appointment">
                            <span>
                                ${window.storeLocator?.button_cta || 'GET A REFERRAL'}
                            </span>
                        </a>
                    </div>
                </div>
            `
            }).join('');

            this.cardList.innerHTML = cardHTML;
            this.storeCards = this.querySelectorAll('.card-store');
            this.handleAppointmentClicks();

        } catch (error) {
            console.error('Failed to load stores:', error);
        }
    }

    handleAppointmentClicks() {
        this.storeCards.forEach(card => {
            const bookBtn = card.querySelector('.js-book-an-appointment');
            bookBtn.addEventListener('click', () => {
                this.updateEmbeddedAppData(card.dataset.id);
                document.getElementsByClassName('convert-to-popup')[0].classList.add('popup-active');
            });
        });
    }

    async initMap() {
        const { Map } = await google.maps.importLibrary("maps");
        const { Place } = await google.maps.importLibrary("places")
    
        this.geocoder = new google.maps.Geocoder();
        
        if(this.showMap) {
            this.map = new Map(this.querySelector('.wrapper-map'), this.mapOptions);
            for (let i = 0; i < this.stores.length; i++) {
                this.addStoreMarker(this.stores[i])
            }
        }
    }

    getTelehealthLabel(store) {
        switch (store?.Telehealth_Appointments?.toLowerCase()) {
            case "yes":
                return window.storeLocator?.telehealth_available || 'Telehealth available';
            case "no":
                return window.storeLocator?.telehealth_unavailable || 'Telehealth not available';
            case "only":
                return window.storeLocator?.telehealth_only || 'Telehealth only';
            default:
                return '';
        }
    }

    showStoreOnMap(event) {
        if(event.target.classList.contains('card-store')) {
            let card = event.target.closest('.card-store')
            let pos = {
                lat: card.dataset.latitude,
                lng: card.dataset.longitude,
            }
            this.map.setCenter(new google.maps.LatLng(pos.lat, pos.lng))
            const marker = this.storeMarkers.find((marker) => marker.store_id == card.dataset.id)
            const store = this.stores.find((store) => store.id == card.dataset.id)

            this.updateEmbeddedAppData(card.dataset.id);

            if(store.Specialty) {
                this.showInfoWindow(marker, store)
            }
        }
    }

    addStoreMarker(store) {
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(store.latitude, store.longitude),
            icon: this.mapOptions.icon,
            map: this.map,
            store_id: store.id,
        });
        this.storeMarkers.push(marker)
        if(store.Specialty) {
            const self = this
            google.maps.event.addListener(marker, 'click', function() {
                self.showInfoWindow(marker, store)
            });
        } else if(store.website) {
            google.maps.event.addListener(marker, 'click', function() {
                window.open(store.website)
            });
        }
    }

    showInfoWindow(marker, store) {
        if (this.infoWindow) {
            this.infoWindow.close();
        }
        let Telehealth_App  = this.getTelehealthLabel(store);

        // Construct the HTML content for the info window
        const info = `
            <div style="font-family: 'Nunito', serif; max-width: 300px;">
                <h2 style="margin: 0; font-size: 16px; color: #000; ${window.storeLocator?.show_doctor_name_map ? '' : 'display: none;'}">
                    ${store.Title} ${store.FName} ${store.LName}
                </h2>
                <p style="${window.storeLocator?.show_doctor_specialty_map ? '' : 'display: none;'}">
                    <span>${store.Specialty}</span>${store.Secondary_Specialty ? `, <span>${store.Secondary_Specialty}</span>` : ''}
                </p>
                <p>
                    <span class="city">${store.city || ''}, </span>
                    <span class="state">${store.state || ''} </span>
                    <span class="zip">${store.zip || ''}</span>
                    <span class="country">${store.country || ''}</span>
                </p>
                <p>
                    <div class="telehealth">${Telehealth_App}</div>
                </p>
                <button id="popup-trigger" style="
                        margin-top: 10px;
                        padding: 8px 12px;
                        background: linear-gradient(to right, #a1cf51 0%, #8dbd4a 51%, #a1cf51 100%);
                        color: white;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                    ">
                    ${window.storeLocator?.button_cta || 'GET A REFERRAL'}
                </button>
            </div>
        `;

        this.infoWindow = new google.maps.InfoWindow({
            content: info,
            ariaLabel: store.name,
            maxWidth: parseInt(this.dataset.infoWindowMaxWidth) || 300,
        });

        this.infoWindow.open({
            anchor: marker,
            map: this.map,
        });

        // Wait for the DOM to render, then attach click handler
        google.maps.event.addListenerOnce(this.infoWindow, 'domready', () => {
            const popupBtn = document.getElementById('popup-trigger');
            if (popupBtn) {
                popupBtn.addEventListener('click', () => {
                    this.updateEmbeddedAppData(store.id);
                    document.querySelector('.convert-to-popup')?.classList.add('popup-active');
                });
            }
        });
    }


    searchPlaces() {
        let address = this.findStoresInput.value
        let self = this
        let radius = parseInt(this.dataset.searchRadius)
        let zoom = parseInt(this.dataset.searchZoom)
        
        if(address.length < 3) {
            self.querySelectorAll('.card-store').forEach(card => card.classList.remove('hidden'));
            this.findStoresResetButton?.classList.add('hidden');
            return
        }
        this.findStoresResetButton?.classList.remove('hidden');
        
        if(this.showMap) {
            for (let i = 0; i < this.storeMarkers.length; i++) {
                this.storeMarkers[i].setMap(null);
            }
            this.storeMarkers = [];
        }
    
        this.geocoder.geocode({
    'address': address,
    componentRestrictions: {
        country: 'us'
    }
}, function(results, status) {
    if (status == 'OK') {
        let pos2 = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
        }
        if (self.showMap) {
            self.map.setCenter(results[0].geometry.location);
            self.map.setZoom(zoom);
            self.dropSearchPin(pos2);
        }

        let physicalStores = [];
        let telehealthStores = [];

        for (let i = 0; i < self.stores.length; i++) {
            let store = self.stores[i];
            let pos1 = {
                lat: store.latitude,
                lng: store.longitude,
            }
            let dst = self.calculateDistance(pos1, pos2);
            let dstLabel = `${dst} <span class="unit">${self.dataset.searchRadiusUnit}</span>`;

            const card = self.querySelector(`.card-store[data-id="${store.id}"]`);
            
            const telehealth = (
                store.telehealth_available === "yes" ||
                store.telehealth_only === "yes" ||
                store.Telehealth_Appointments?.toLowerCase() === "yes" ||
                store.Telehealth_Appointments?.toLowerCase() === "only"
            );

            if (dst <= radius) {
                store.dst = dst;
                physicalStores.push(store);
                card.classList.remove('hidden');
                card.querySelector('.distance').innerHTML = dstLabel;
            } else if (telehealth) {
                store.dst = dst;
                telehealthStores.push(store);
                card.classList.remove('hidden');
                card.querySelector('.distance').innerHTML = '';
            } else {
                card.classList.add('hidden');
                card.style.order = 0;
                card.querySelector('.distance').innerHTML = '';
            }
        }

        physicalStores.sort((a, b) => a.dst - b.dst);
        let closeStores = [...physicalStores, ...telehealthStores];

        let j = 0;
        closeStores.forEach((store) => {
            if (self.showMap) {
                self.addStoreMarker(store);
            }
            j++;
            self.querySelector(`.card-store[data-id="${store.id}"]`).style.order = -100 + j;
        });
    } else {
        console.log('Geocode was not successful for the following reason: ' + status);
    }
});

    }

    dropSearchPin(pos) {
        let radius = parseInt(this.dataset.searchRadius)
        if(this.dataset.searchRadiusUnit == 'km') {
            radius*= 1000
        } else {
            radius*= 1609.34
        }
        if(this.searchMarker) {
            this.searchMarker.setMap(null)
        }
        this.searchMarker = new google.maps.Marker({
            position: new google.maps.LatLng(pos.lat, pos.lng),
            map: this.map,
        });
        if(this.cityCircle) {
            this.cityCircle.setMap(null)
        }
        this.cityCircle = new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.2,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.05,
            map: this.map,
            center: pos,
            radius: radius,
        });
    }

    calculateDistance(pos1, pos2) {
        var R = 3958.8; // Radius of the Earth in miles
        if(this.dataset.searchRadiusUnit == 'km') {
            R = 6378; // Radius of the Earth in kilometers
        }
        var rlat1 = pos1.lat * (Math.PI/180); // Convert degrees to radians
        var rlat2 = pos2.lat * (Math.PI/180); // Convert degrees to radians
        var difflat = rlat2-rlat1; // Radian difference (latitudes)
        var difflon = (pos2.lng-pos1.lng) * (Math.PI/180); // Radian difference (longitudes)
    
        var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
        d = Math.round((d + Number.EPSILON) * 100) / 100
        return d.toString();
    }

    resetMap() {
        if (this.showMap) {
            if (this.searchMarker) {
                this.searchMarker.setMap(null);
                this.searchMarker = null;
            }
            if (this.cityCircle) {
                this.cityCircle.setMap(null);
                this.cityCircle = null;
            }
            this.storeMarkers.forEach(marker => marker.setMap(null));
            this.storeMarkers = [];
            this.stores.forEach(store => this.addStoreMarker(store));
            this.map.setCenter(this.mapOptions.center);
            this.map.setZoom(this.mapOptions.zoom);
        }
    }
    
    updateEmbeddedAppData(storeId) {
        const store = this.stores.find((store) => store.id == storeId);
        if (!store) return;

        const host = document.getElementById('app-embed');
        if (!host || !host.shadowRoot) return;

        const targetElement = host.shadowRoot.querySelector('#custom\\#syncdata');
        if (!targetElement) return;

        targetElement.value = JSON.stringify(store);
        targetElement.dispatchEvent(new Event('input', { bubbles: true }));
        targetElement.dispatchEvent(new Event('change', { bubbles: true }));
    }

    initBookingPopup() {

        let intervalId = setInterval(() => {
            const shopifySection = document.getElementById('app-embed')?.closest('.shopify-section');
            if (shopifySection) {
                shopifySection.classList.add('convert-to-popup');

                // Close button
                const closeBtn = document.createElement('button');
                closeBtn.innerHTML = '&times;';
                closeBtn.classList.add('popup_close-btn');
                closeBtn.addEventListener('click', () => {
                    shopifySection.classList.remove('popup-active');
                });
                // Escape key to close popup
                document.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape') {
                        shopifySection.classList.remove('popup-active');
                    }
                });
                shopifySection.querySelector('.shopify-app-block').appendChild(closeBtn);

                // Hide the custom sync data element
                const host = document.getElementById('app-embed');
                const shadowRoot = host.shadowRoot;
                const targetElement = shadowRoot.querySelector('#custom\\#syncdata');
                targetElement.closest('div').style.display = 'none';
                targetElement.closest('form').querySelector('button[type=submit]').style.backgroundImage = 'linear-gradient(to right, #a1cf51 0%, #8dbd4a 51%, #a1cf51 100%)';

                clearInterval(intervalId);
            }
        }, 500);
    }
}

customElements.define('dusk-store-locator', DuskStoreLocator);
